import React from 'react';

export default function ProgressDonut({ progress, size = 40 }) {
  const normalizedProgress = Math.min(Math.max(progress || 0, 0), 1);
  const strokeWidth = Math.max(3, Math.floor(size / 12));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - normalizedProgress * circumference;

  let colorClass = 'text-green-500';
  if (normalizedProgress < 0.3) colorClass = 'text-red-500';
  else if (normalizedProgress < 0.7) colorClass = 'text-yellow-500';
  else if (normalizedProgress >= 1.0) colorClass = 'text-green-600';

  const percentage = (normalizedProgress * 100).toFixed(0);
  const fontSize = size <= 32 ? 'text-[10px]' : size <= 40 ? 'text-xs' : 'text-sm';

  return (
    <div className="relative flex items-center justify-center" style={{ width: size, height: size }}>
      <svg className="absolute" width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle className="text-gray-200" stroke="currentColor" strokeWidth={strokeWidth} fill="transparent" r={radius} cx={size / 2} cy={size / 2} />
        <circle className={colorClass} stroke="currentColor" strokeWidth={strokeWidth} fill="transparent" r={radius} cx={size / 2} cy={size / 2} strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" style={{ transition: 'stroke-dashoffset 0.5s ease-in-out, stroke 0.3s ease-in-out' }} />
      </svg>
      <span className={`${fontSize} font-semibold text-gray-700 z-10`}>{percentage}%</span>
    </div>
  );
}
